import React, { Component } from 'react';
import { Row, Col, Button, Form } from 'antd'
import QRCodeGenerator from './QRCodeGenerator';
import ModalExport from '../ExportPreview/ModalExport';
import HOME from '../../constants/home-constant';

const QRCodeWithButton = ({ home, dispatch, form, resetBtn }) => {
  
  const clearFormData = () => {
    dispatch({ type: HOME.RESET_PROP}); 
    form.resetFields();
    // form.setFieldsValue({
    //   concentration: 1
    // });
    resetBtn();
  }

  const submitTestForm = () => {
    dispatch({ type: HOME.SET_PROP, value: true, prop: 'saveBtn' });
    dispatch({ type: HOME.SET_PROP, value: false, prop: 'previewData' });
    dispatch({ type: HOME.SET_PROP, value: true, prop: 'modalShow' });
  }
  
  return (
    <div className="qr-code-container">
      <Row gutter={[16, 8]}>
        <Col span={24}>
          <div style={{ border: '1px solid #ccc', height: '140px' }}>
            {home && home.qrCode ? <QRCodeGenerator value={home.currentData[0]} size={169} /> : ""}
          </div>
        </Col>
        <Col span={24}>
          <Button disabled={home.qrCode} htmlType="submit" type="primary" icon="snippets" className="primary-dark" block>Generate</Button>
        </Col>
        {/* <Col span={24}>
          <Button disabled={!home.qrCode || !home.isSaveClick} htmlType="submit" type="primary" icon="save" className="primary-dark" block onClick={
            () => submitTestForm()}
          >Save</Button>
        </Col> */}
        <Col span={24}>
          <Button disabled={!home.qrCode} icon="export"  htmlType="submit" type="primary" className="primary-dark" block onClick={
            () => {
              submitTestForm()
            }}
          >Print/Export</Button>
        </Col>
        <Col span={24}>
          <Button type="primary" icon="delete" className="primary-dark" onClick={
            () => clearFormData()} block
          >Clear</Button>
        </Col>
        {/* {
          ((home.showID) && home.currentData[0] && home.currentData[0].id) && ( 
            <Col span={24}>
              <Button type="link" disabled block>{`# ${home.currentData[0].id}`}</Button>
            </Col>
          )
        } */}
      </Row>
      <ModalExport home={home} dispatch={dispatch} />
    </div>
  )
}

export default QRCodeWithButton;
